import { Interweave } from "interweave";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import
{
  BASE_URL,
  GET_CONTENTS_BY_MENU_ID,
  GET_IMAGE_BY_MENU_ID,
  GET_MENUS_ALL_NESTED,
} from "../../constant/constants";

const settings = {
  dots: true,
  arrows: false,
  speed: 1000,
  slidesToShow: 2,
  slidesToScroll: 1,
  autoplay: true,
  responsive: [
    { breakpoint: 1500, settings: { slidesToShow: 2, slidesToScroll: 1 } },
    { breakpoint: 1200, settings: { slidesToShow: 2, slidesToScroll: 1 } },
    { breakpoint: 991, settings: { slidesToShow: 2, slidesToScroll: 1 } },
    { breakpoint: 767, settings: { slidesToShow: 2, slidesToScroll: 1 } },
    { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } },
  ],
};

function items ( obj )
{
  const content = [];
  for ( const key in obj )
  {
    if ( Object.prototype.hasOwnProperty.call( obj, key ) )
    {
      const contentItem = { [ key ]: obj[ key ] };
      content.push( contentItem );
    }
  }
  return content;
}

const WithOutBlogSilder = ( props ) =>
{
  console.log( "props", props );
  const [ contents, setContents ] = useState( [] );
  const [ contentsImage, setContentsImage ] = useState( "" );
  const [ homeId, setHomeId ] = useState();

  console.log( "contentsEvent", contentsImage );

  const { id } = useParams();
  useEffect( () =>
  {
    fetch( `${ GET_MENUS_ALL_NESTED }` )
      .then( ( response ) => response.json() )
      .then( ( data ) =>
      {
        data.menus.find( ( e ) => ( e.name === "Home" ? setHomeId( e.id ) : null ) );
      } )
      .catch( () => { } );
  }, [] );

  useEffect( () =>
  {
    const fetchData = async () =>
    {
      try
      {
        const imageResponse = await fetch(
          `${ GET_IMAGE_BY_MENU_ID }/${ homeId || id || props.id }`
        );
        const imageData = await imageResponse.json();
        setContentsImage( imageData.content_images );
        console.log( "imagesContent", imageData );

        const contentResponse = await fetch(
          `${ GET_CONTENTS_BY_MENU_ID }/${ homeId || id || props.id }`
        );
        const contentData = await contentResponse.json();

        setContents( contentData?.menu_contents );
        console.log( "LiveEvents", contentData?.menu_contents );
      } catch ( error )
      {
        console.error( "Error fetching data:", error );
      }
    };

    fetchData();
  }, [ id, props.id, homeId ] );


  console.log( "Efdsfdsff", contents, contentsImage );

  return (
    <section className="wpo-features-section-s6 section-padding">
      <div className="container">

        <div className="row">

          { contents.map( ( service, index ) =>
          {
            console.log( "service00000", service );
            if (
              service.name === "About" ||
              service.name === "Partner" ||
              service.name === "Our Services" ||
              service.name === "Companies" ||
              service.name === "Featured Work"
            )
            {
              return null;
            }
            return (
              <div
                className="col col-xl-6 col-lg-6 col-sm-6 col-12 p-3"
                key={ index }
              >
                <Link
                  to={ `/blogs details/${ homeId || id || props.id }/${ service?.name
                    }` }
                >
                  <div
                    className="wpo-features-item p-0"
                    style={ { borderRadius: "20px", width: '100%', height: '660px', padding: '40px 0' } }

                  >
                    { contentsImage &&
                      service?.name &&
                      contentsImage[ service.name ] ? (
                      <div>
                        <div>
                          <img
                            style={ {
                              display: "block",
                              width: "100%",
                              marginLeft: "auto",
                              marginRight: "auto",
                              height:
                                window.innerWidth < 768 ? "200px" : "400px",
                            } }
                            src={ `${ BASE_URL }/media/${ contentsImage[ service.name ]
                              }` }
                            alt=""
                          />
                        </div>
                        <div
                          style={ {
                            padding: "10px 20px",
                            minHeight: "200px",
                          } }
                        >
                          <Interweave
                            allowAttributes
                            allowElements
                            disableLineBreaks={ true }
                            content={ `${ service.value.slice(
                              0,
                              300
                            ) } .see more` }
                          />
                        </div>
                      </div>
                    ) : (
                      <div
                        className="wpo-features-item p-0"
                        style={ { borderRadius: "20px" } }
                      >
                        <iframe
                          title={ service.value }
                          src={ service?.post_link }
                          width="100%"
                          height="660"
                          style={ { border: "none", overflow: "hidden" } }
                          scrolling="no"
                          frameBorder="0"
                          allowFullScreen={ true }
                          allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                        ></iframe>
                      </div>
                    ) }
                  </div>
                </Link>
              </div>
            );
          } ) }

        </div>
      </div>
    </section>
  );
};

export default WithOutBlogSilder;
